import { THEME_SETTINGS_BUFFER_PUBLISHED, THEME_SETTINGS_REVERTED, THEME_SETTINGS_REVISIONS_FETCHED, CLEAR_THEME_SETTINGS_REVISIONS } from '../actions/ActionTypes';
import * as RequestStatusTypes from '../constants/RequestStatusTypes';
const initialState = {
  revisions: [],
  hasMoreRevisions: false,
  requestOffset: 0,
  requestStatus: RequestStatusTypes.UNINITIALIZED,
  revertRequestStatus: RequestStatusTypes.UNINITIALIZED,
  totalRevisionCount: 0
};
const revisionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case THEME_SETTINGS_REVERTED:
      return Object.assign({}, state, {
        revertRequestStatus: action.requestStatus
      });
    case THEME_SETTINGS_REVISIONS_FETCHED:
      {
        if (action.requestStatus === RequestStatusTypes.SUCCEEDED) {
          const {
            results,
            total,
            hasMore,
            offset
          } = action.payload;
          const revisions = results || [];
          const newRevisions = [...state.revisions, ...revisions];
          return Object.assign({}, state, {
            revisions: newRevisions,
            hasMoreRevisions: hasMore,
            requestOffset: offset.offset,
            requestStatus: RequestStatusTypes.SUCCEEDED,
            totalRevisionCount: total
          });
        }
        return Object.assign({}, state, {
          requestStatus: action.requestStatus
        });
      }
    case THEME_SETTINGS_BUFFER_PUBLISHED:
    case CLEAR_THEME_SETTINGS_REVISIONS:
      return initialState;
    default:
      return state;
  }
};
export default revisionsReducer;